(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ie-about-numbers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-about-numbers')) {
    customElements.define('ie-about-numbers', class extends HTMLElement {
      connectedCallback() {
        this.nums = [...this.querySelectorAll('[data-count]')];
        if (!this.nums.length || this.hasAttribute('data-still') || window.Shopify?.designMode) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.band = this.querySelector('.ie-abn__band');
        this.nums.forEach((el) => { el.dataset.final = el.textContent; el.textContent = '0'; });
        // Position check on scroll (not IntersectionObserver alone, so a jump scroll still starts it).
        // Capture phase: on desktop Atelier scrolls .page-wrapper, whose scroll events don't bubble to window.
        this.onScroll = () => {
          if (!this.band.getClientRects().length) return;
          if (this.band.getBoundingClientRect().top < innerHeight * 0.85) this.run();
        };
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        requestAnimationFrame(() => this.onScroll && this.onScroll());
      }
      run() {
        this.stop();
        this.nums.forEach((el) => {
          const to = +el.dataset.count, final = el.dataset.final, d = 1500;
          let t0 = 0;
          const step = (t) => {
            if (!t0) t0 = t;
            const k = Math.min(1, (t - t0) / d);
            el.textContent = k < 1 ? Math.round(to * (1 - Math.pow(1 - k, 3))).toLocaleString('en-IN') : final;
            if (k < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        });
      }
      stop() {
        if (!this.onScroll) return;
        document.removeEventListener('scroll', this.onScroll, true);
        window.removeEventListener('resize', this.onScroll);
        this.onScroll = null;
      }
      disconnectedCallback() {
        this.stop();
        this.nums?.forEach((el) => { if (el.dataset.final) el.textContent = el.dataset.final; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-about-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-about-story')) {
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
    customElements.define('ie-about-story', class extends HTMLElement {
      connectedCallback() {
        this.pin = this.querySelector('.ie-abs__pin');
        this.head = this.querySelector('.ie-abs__head');
        this.deck = this.querySelector('.ie-abs__deck');
        this.cards = [...this.querySelectorAll('.ie-abs__card')];
        this.segs = [...this.querySelectorAll('.ie-abs__seg')];
        this.now = this.querySelector('.ie-abs__count b');
        this.n = this.cards.length;
        if (this.n < 2) return;
        this.pos = null;
        this.cur = 0;
        this.frameFn = (t) => this.frame(t);

        this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotion = () => this.setup();
        this.reduce.addEventListener('change', this.onMotion);
        // Atelier scrolls .page-wrapper on computers: a capturing listener on document hears every scroller
        this.onScroll = () => { if (this.live) this.kick(); };
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
        this.onResize = () => this.layout();
        window.addEventListener('resize', this.onResize);
        this.ro = new ResizeObserver(() => this.layout());
        this.ro.observe(this.head);
        this.ro.observe(this.deck);
        const hdr = document.querySelector('.ie-hdr, #header-component');
        if (hdr) this.ro.observe(hdr);
        this.segs.forEach((b, k) => b.addEventListener('click', () => this.go(k)));
        // theme editor: show the card being edited
        this.onSelect = (e) => { const i = this.cards.indexOf(e.target); if (i >= 0) this.go(i, true); };
        document.addEventListener('shopify:block:select', this.onSelect);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.layout(true));
        this.setup();
      }
      disconnectedCallback() {
        this.reduce?.removeEventListener('change', this.onMotion);
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:block:select', this.onSelect);
        this.ro?.disconnect();
        this.running = false;
      }
      setup() {
        this.live = !this.reduce.matches && !this.hasAttribute('data-still');
        this.classList.toggle('is-live', this.live);
        this.lastW = this.lastVh = null;
        if (this.live) {
          this.layout(true);
        } else {
          this.running = false;
          this.style.height = '';
          this.classList.remove('is-short');
          this.cards.forEach((c) => { c.style.transform = c.style.opacity = c.style.zIndex = c.style.visibility = ''; });
        }
      }
      layout(force) {
        if (!this.live) return;
        const W = this.deck.clientWidth;
        if (!W) return;
        const vh = document.documentElement.clientHeight;
        // the pin sits right under the sticky header (the header keeps --header-height exact; 0 when it does not stick)
        const top = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
        // phones: ignore the browser bar sliding in and out, it would make the page jump
        const same = W === this.lastW && top === this.top && this.head.offsetHeight === this.lastHeadH;
        if (!force && same && (vh === this.lastVh || matchMedia('(pointer: coarse)').matches)) return;
        this.lastW = W;
        this.lastVh = vh;
        const m = matchMedia('(max-width: 640px)').matches;
        const room = vh - top;
        this.top = top;
        this.style.setProperty('--ie-abs-top', top + 'px');
        this.classList.toggle('is-short', room < 640);
        const cs = getComputedStyle(this);
        this.padS = parseFloat(cs.paddingTop) || 0;
        this.padB = parseFloat(cs.paddingBottom) || 0;
        const pad = parseFloat(getComputedStyle(this.pin).paddingTop) || 0;
        this.lastHeadH = this.head.offsetHeight;
        const headH = this.lastHeadH + (parseFloat(getComputedStyle(this.head).marginBottom) || 0);
        this.peek = m ? 8 : 10;
        this.tilt = m ? 28 : 38;
        const peekH = this.peek * Math.min(3, this.n - 1);
        const shadow = 36; // room under the stack so the soft card shadow is not cut off
        this.ch = Math.round(clamp(room - pad - headH - peekH - shadow, m ? 300 : 280, m ? 470 : 440));
        this.style.setProperty('--ie-abs-ch', this.ch + 'px');
        this.style.setProperty('--ie-abs-peek', peekH + 'px');
        this.pinH = Math.min(room, Math.ceil(pad + headH + this.ch + peekH + shadow));
        this.style.setProperty('--ie-abs-pin-h', this.pinH + 'px');
        this.per = Math.round(Math.max(220, this.ch * 0.6)); // page scroll per card
        this.len = (this.n - 1) * this.per;
        this.lift = this.ch + pad + headH + 40;
        this.style.height = Math.round(this.padS + this.pinH + this.len + this.padB) + 'px';
        this.last = null;
        if (this.pos === null) this.pos = this.progress();
        this.place();
        this.kick();
      }
      progress() {
        if (!(this.len > 0)) return 0;
        const r = this.getBoundingClientRect();
        return clamp((this.top - (r.top + this.padS)) / this.len, 0, 1) * (this.n - 1);
      }
      kick() {
        if (this.running || !this.live || this.pos === null) return;
        this.running = true;
        this.t = 0;
        requestAnimationFrame(this.frameFn);
      }
      frame(t) {
        if (!this.running) return;
        const dt = this.t ? Math.min(0.05, (t - this.t) / 1000) : 0;
        this.t = t;
        const tg = this.progress();
        this.pos += (tg - this.pos) * (1 - Math.exp(-dt * 9));
        if (Math.abs(tg - this.pos) < 0.0008) this.pos = tg;
        this.place();
        if (this.pos !== tg || !dt) requestAnimationFrame(this.frameFn);
        else this.running = false;
      }
      place() {
        const pos = this.pos, n = this.n;
        if (this.last !== null && Math.abs(pos - this.last) < 0.0004) return;
        this.last = pos;
        this.cards.forEach((c, i) => {
          const d = i - pos;
          let ty, rx = 0, sc = 1, op = 1;
          if (d < 0) {
            // passed: tip back and slide up behind the heading row
            const k = Math.min(1, -d);
            ty = -this.lift * k * k * (3 - 2 * k);
            rx = this.tilt * (1 - Math.pow(1 - k, 3));
            op = k < 0.7 ? 1 : 1 - (k - 0.7) / 0.3;
          } else {
            // waiting: a thin strip of each next card peeks out under the front one
            ty = d * this.peek;
            sc = 1 - d * 0.04;
            op = clamp(3.6 - d, 0, 1);
          }
          c.style.transform = `translate3d(0,${ty.toFixed(1)}px,0) perspective(1200px) rotateX(${rx.toFixed(2)}deg) scale(${sc.toFixed(4)})`;
          c.style.opacity = op.toFixed(3);
          c.style.zIndex = n - i;
          c.style.visibility = op <= 0 ? 'hidden' : 'visible';
        });
        this.segs.forEach((b, k) => b.style.setProperty('--f', k ? clamp(pos - k + 1, 0, 1).toFixed(3) : 1));
        const a = clamp(Math.round(pos), 0, n - 1);
        if (a !== this.cur) {
          this.cur = a;
          if (this.now) this.now.textContent = String(a + 1).padStart(2, '0');
          this.segs.forEach((b, k) => (k === a ? b.setAttribute('aria-current', 'step') : b.removeAttribute('aria-current')));
        }
      }
      scroller() {
        const w = document.querySelector('.page-wrapper');
        if (w && w.scrollHeight > w.clientHeight + 5 && /(auto|scroll)/.test(getComputedStyle(w).overflowY)) return w;
        return document.scrollingElement || document.documentElement;
      }
      go(k, instant) {
        const sc = this.scroller();
        if (!this.live) {
          const c = this.cards[k];
          if (c) c.scrollIntoView({ block: 'center', behavior: instant || this.reduce.matches ? 'instant' : 'smooth' });
          return;
        }
        // where the page has to be so that card k is at the front (1px into its step; the last card = end of the pin)
        const r = this.getBoundingClientRect();
        const y = Math.max(0, Math.round(sc.scrollTop + r.top + this.padS - this.top + k * this.per + (k < this.n - 1 ? 1 : 0)));
        if (window.ieLenis && sc !== document.scrollingElement && !instant) window.ieLenis.scrollTo(y);
        else sc.scrollTo({ top: y, behavior: instant ? 'instant' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-announce')) {
    customElements.define('ie-announce', class extends HTMLElement {
      connectedCallback() {
        this.msgs = [...this.querySelectorAll('.ie-ann__msg')];
        if (this.msgs.length < 2) return;
        this.i = 0;
        this.ms = (Number(this.dataset.speed) || 5) * 1000;
        this.still = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.addEventListener('click', (e) => {
          const b = e.target.closest('[data-ann]');
          if (b) { this.go(this.i + Number(b.dataset.ann)); this.start(); }
        });
        // Hold still while the shopper is reading or tabbing through it
        this.addEventListener('pointerenter', () => this.stop());
        this.addEventListener('pointerleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.onSelect = (e) => {
          const k = this.msgs.indexOf(e.target);
          if (k > -1) { this.go(k); this.stop(); this.held = true; }
        };
        document.addEventListener('shopify:block:select', this.onSelect);
        this.start();
      }
      disconnectedCallback() {
        this.stop();
        document.removeEventListener('shopify:block:select', this.onSelect);
      }
      start() {
        this.stop();
        if (this.still || this.held) return;
        this.timer = setInterval(() => this.go(this.i + 1), this.ms);
      }
      stop() { clearInterval(this.timer); }
      go(n) {
        this.i = (n + this.msgs.length) % this.msgs.length;
        this.msgs.forEach((m, k) => m.classList.toggle('is-on', k === this.i));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-brands"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-brands')) {
    customElements.define('ie-brands', class extends HTMLElement {
      connectedCallback() {
        this.wall = this.querySelector('.ie-brands__wall');
        this.tiles = [...this.querySelectorAll('.ie-brands__tile')];
        this.dots = [...this.querySelectorAll('.ie-brands__dot')];
        if (!this.wall || this.dots.length < 2) return;
        if (!this.bound) {
          // element listeners are added once (the theme editor can move a section, which reconnects it)
          this.bound = true;
          // the indicator follows the swipe
          this.wall.addEventListener('scroll', () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.sync());
          }, { passive: true });
          this.addEventListener('click', (e) => {
            const d = e.target.closest('[data-dot]');
            if (d) this.go(Number(d.dataset.dot));
          });
        }
        // theme editor: show the tile being edited
        this.onSelect = (e) => {
          const k = this.tiles.indexOf(e.target);
          if (k > -1) this.go(k, true);
        };
        document.addEventListener('shopify:block:select', this.onSelect);
        this.sync();
      }
      disconnectedCallback() {
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
      }
      step() {
        const t = this.tiles[0];
        return t ? t.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.wall).columnGap) || 0) : 1;
      }
      go(i, instant) {
        const still = instant || matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.wall.scrollTo({ left: i * this.step(), behavior: still ? 'instant' : 'smooth' });
      }
      sync() {
        const w = this.wall;
        const max = w.scrollWidth - w.clientWidth;
        const last = this.tiles.length - 1;
        let i = Math.round(w.scrollLeft / this.step());
        if (max > 0 && w.scrollLeft >= max - 4) i = last;
        i = Math.max(0, Math.min(last, i));
        this.dots.forEach((d, k) => {
          d.classList.toggle('is-on', k === i);
          if (k === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-category-flow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-category-flow')) {
    customElements.define('ie-category-flow', class extends HTMLElement {
      connectedCallback() {
        this.pin = this.querySelector('.ie-cf__pin');
        this.info = this.querySelector('.ie-cf__info');
        this.stage = this.querySelector('.ie-cf__stage');
        this.track = this.querySelector('.ie-cf__track');
        this.labelBox = this.querySelector('.ie-cf__labels');
        this.cards = [...this.querySelectorAll('.ie-cf__card')];
        this.n = this.cards.length;
        if (!this.n) return;
        this.titles = [...this.querySelectorAll('.ie-cf__title')];
        this.descs = [...this.querySelectorAll('.ie-cf__descs > *')];
        this.btns = [...this.querySelectorAll('.ie-cf__btn')];
        this.labels = [...this.querySelectorAll('.ie-cf__label')];
        // cards that share a category keep the text on screen instead of fading it out and back in
        const key = (i) => [this.titles[i], this.descs[i], this.btns[i]].map((e) => (e ? e.innerHTML : '')).join('|');
        const lkey = (i) => (this.labels[i] ? this.labels[i].outerHTML : '');
        this.infoOwner = this.cards.map((_, i) => { for (let j = 0; j < i; j++) if (key(j) === key(i)) return j; return i; });
        this.labelOwner = this.cards.map((_, i) => { for (let j = 0; j < i; j++) if (lkey(j) === lkey(i)) return j; return i; });
        this.cur = -1; // nothing shown yet: the first show() always applies
        this.man = 0;
        this.pos = null;
        this.frameFn = (t) => this.frame(t);

        this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotion = () => this.setup();
        this.reduce.addEventListener('change', this.onMotion);

        this.onScroll = () => {
          if (!this.flow) return;
          // once the section is fully off screen, forget extra steps taken by clicks so the next visit starts clean
          if (this.man) {
            const r = this.getBoundingClientRect();
            if (r.bottom < 0 || r.top > innerHeight) { this.man = 0; this.pos = this.target(); this.last = null; this.place(); return; }
          }
          this.kick();
        };
        // Atelier scrolls .page-wrapper on computers: a capturing listener on document hears every scroller
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
        this.onResize = () => (this.flow ? this.layout() : this.bleed());
        window.addEventListener('resize', this.onResize);
        this.ro = new ResizeObserver(() => (this.flow ? this.layout() : this.bleed()));
        this.ro.observe(this.pin);
        this.ro.observe(this.info);
        const hdr = document.querySelector('.ie-hdr, #header-component');
        if (hdr) this.ro.observe(hdr);
        // theme editor: bring the card being edited to the middle
        this.onSelect = (e) => {
          const i = this.cards.indexOf(e.target);
          if (i < 0) return;
          if (this.flow) { this.man += Math.round(this.wrap(i - this.target())); this.kick(); } // editor: no page scroll
          else this.centreRow(i, true);
        };

        document.addEventListener('shopify:block:select', this.onSelect);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.layout(true));
        if (!this.bound) this.bind(); // element listeners survive the editor moving the section, add them once
        this.setup();
      }
      bind() {
        this.bound = true;
        // a click on a side card brings it to the middle; the middle card keeps its link to the product
        this.stage.addEventListener('click', (e) => {
          const c = e.target.closest('.ie-cf__card');
          if (!c) return;
          const i = Number(c.dataset.i);
          if (this.flow) {
            const d = Math.round(this.wrap(i - this.target()));
            if (d !== 0) { e.preventDefault(); this.go(d); }
            else if (Math.abs(this.wrap(i - this.pos)) > 0.35) e.preventDefault(); // still sliding in
          } else if (i !== this.cur) {
            e.preventDefault();
            this.centreRow(i);
          }
        }, true);
        this.stage.addEventListener('dragstart', (e) => e.preventDefault());
        // keyboard: a side card that gets focus slides to the middle
        this.stage.addEventListener('focusin', (e) => {
          const c = e.target.closest('.ie-cf__card');
          if (!c || !c.matches(':focus-visible')) return;
          const i = Number(c.dataset.i);
          if (this.flow) this.go(Math.round(this.wrap(i - this.target())));
          else this.centreRow(i);
        });
        // sideways swipe on the cards also steps them (vertical swipes scroll the page as usual)
        this.stage.addEventListener('touchstart', (e) => { const t = e.touches[0]; this.sx = t.clientX; this.sy = t.clientY; }, { passive: true });
        this.stage.addEventListener('touchend', (e) => {
          if (!this.flow || this.sx == null) return;
          const t = e.changedTouches[0], dx = t.clientX - this.sx, dy = t.clientY - this.sy;
          this.sx = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) this.go(dx < 0 ? 1 : -1);
        }, { passive: true });
        // plain row: the text follows the card in the middle
        this.track.addEventListener('scroll', () => {
          if (this.flow) return;
          cancelAnimationFrame(this.rowRaf);
          this.rowRaf = requestAnimationFrame(() => this.syncRow());
        }, { passive: true });
      }
      disconnectedCallback() {
        this.reduce?.removeEventListener('change', this.onMotion);
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:block:select', this.onSelect);
        this.ro?.disconnect();
        this.running = false;
      }
      setup() {
        this.flow = !this.reduce.matches;
        this.classList.toggle('is-flow', this.flow);
        this.lastW = this.lastVh = null;
        if (this.flow) {
          this.style.removeProperty('--ie-cf-bleed');
          this.layout(true);
        } else {
          this.style.height = '';
          this.classList.remove('is-short');
          this.cards.forEach((el) => { el.style.transform = el.style.opacity = el.style.zIndex = el.style.visibility = ''; });
          this.bleed(true);
        }
      }
      // plain row: stretch the row from the page column to the screen edges, keep the current card in the middle
      bleed(force) {
        const wrap = this.stage.parentElement, cs = getComputedStyle(wrap);
        const inner = wrap.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        const side = Math.max(0, Math.floor((this.clientWidth - inner) / 2));
        const W = this.track.clientWidth;
        if (!force && side === this.side && W === this.rowW) return;
        this.side = side;
        this.style.setProperty('--ie-cf-bleed', side + 'px');
        this.rowW = this.track.clientWidth;
        this.centreRow(Math.max(0, this.cur), true);
      }
      wrap(d) {
        const n = this.n;
        return ((d + n / 2) % n + n) % n - n / 2;
      }
      layout(force) {
        if (!this.flow) return;
        const W = this.stage.clientWidth;
        if (!W) return;
        const vh = document.documentElement.clientHeight;
        // the pin sits right under the sticky header (Atelier keeps --header-height up to date)
        const top = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
        // phones: ignore the browser bar sliding in and out, it would make the page jump
        const same = W === this.lastW && top === this.hdr && this.info.offsetHeight === this.lastInfoH;
        if (!force && same && (vh === this.lastVh || matchMedia('(pointer: coarse)').matches)) return;
        this.lastW = W;
        this.lastVh = vh;
        const m = W < 700;
        const room = vh - top;
        this.hdr = top;
        this.classList.toggle('is-short', room < 700);
        const cs = getComputedStyle(this);
        this.padS = parseFloat(cs.paddingTop) || 0;
        this.padB = parseFloat(cs.paddingBottom) || 0;
        const padT = parseFloat(getComputedStyle(this.pin).paddingTop) || 0;
        const infoH = this.info.offsetHeight, infoM = parseFloat(getComputedStyle(this.info).marginBottom) || 0;
        this.lastInfoH = infoH;
        const labH = this.labelBox.offsetHeight, labM = parseFloat(getComputedStyle(this.labelBox).marginTop) || 0;
        const gap = m ? 12 : 18;
        const avail = room - padT - infoH - infoM - labH - labM - gap - (m ? 8 : 10);
        let cw = m ? W * 0.66 : Math.min(440, W * 0.32);
        let ch = cw / 0.75;
        if (ch > avail) { ch = Math.max(170, avail); cw = Math.min(cw, ch * (m ? 0.75 : 0.86)); }
        this.cw = cw;
        this.spread = m ? 0.62 : 1;
        this.maxD = Math.min(m ? 2.6 : 3.6, this.n / 2); // a card wrapping round the back is never visible
        this.style.setProperty('--ie-cf-w', cw.toFixed(2) + 'px');
        this.style.setProperty('--ie-cf-ch', ch.toFixed(2) + 'px');
        this.style.setProperty('--ie-cf-h', (ch + gap).toFixed(2) + 'px');
        const need = padT + infoH + infoM + ch + gap + labM + labH + 8;
        this.pinH = Math.min(room, Math.ceil(need));
        this.style.setProperty('--ie-cf-pin-h', this.pinH + 'px');
        // tall screens (tablets, long phones) have room to spare: the stage sticks in the middle of it, not at the top
        this.top = top + Math.max(0, Math.floor((room - this.pinH) / 2));
        this.style.setProperty('--ie-cf-top', this.top + 'px');
        this.per = m ? 170 : 210; // page scroll per card
        this.scrollLen = (this.n - 1) * this.per;
        this.style.height = Math.round(this.padS + this.pinH + this.scrollLen + this.padB) + 'px';
        this.last = null;
        if (this.pos === null) this.pos = this.target();
        this.place();
        this.kick();
      }
      // the element that scrolls the page: .page-wrapper on computers (Atelier), the document below 990px
      scroller() {
        const w = document.querySelector('.page-wrapper');
        return w && w.scrollHeight > w.clientHeight + 5 && /auto|scroll/.test(getComputedStyle(w).overflowY) ? w : document.scrollingElement;
      }
      // smooth scrolling (Lenis) glides the page towards a target: steer the cards by where the page is heading,
      // so a wheel step starts the card slide at once instead of easing on top of the page's own easing
      ahead() {
        const l = window.ieLenis;
        if (!l || l.isScrolling !== 'smooth' || typeof l.targetScroll !== 'number') return 0;
        const w = l.options && l.options.wrapper, cur = w && w !== window ? w.scrollTop : window.scrollY;
        const d = l.targetScroll - cur;
        return Number.isFinite(d) ? d : 0;
      }
      raw() {
        const r = this.getBoundingClientRect();
        return (this.top - (r.top + this.padS) + this.ahead()) / this.per;
      }
      progress() {
        if (!(this.scrollLen > 0)) return 0;
        return Math.min(this.n - 1, Math.max(0, this.raw()));
      }
      // move d cards: while the section is pinned, scroll the page to that card's step (page and cards stay in step,
      // the pin still lets go after the last card); otherwise, or past either end, just turn the cards
      go(d) {
        if (!d) return;
        const n = this.n, raw = this.raw(), next = Math.round(Math.min(n - 1, Math.max(0, raw))) + d;
        const sc = this.scroller();
        if (sc && raw > -0.05 && raw < n - 0.95 && next >= 0 && next <= n - 1) {
          const y = Math.round((window.ieLenis && typeof window.ieLenis.targetScroll === 'number' && sc !== document.scrollingElement ? window.ieLenis.targetScroll : sc.scrollTop)
            + (next - raw) * this.per) + (next === n - 1 ? -1 : 1); // land just inside the step, never past the release
          if (window.ieLenis && sc !== document.scrollingElement) window.ieLenis.scrollTo(y);
          else sc.scrollTo({ top: y, behavior: 'smooth' });
          this.kick();
        } else {
          this.man += d;
          this.kick();
        }
      }
      target() {
        return Math.round(this.progress()) + this.man;
      }
      kick() {
        if (this.running || !this.flow || this.pos === null) return;
        this.running = true;
        this.t = 0;
        requestAnimationFrame(this.frameFn);
      }
      frame(t) {
        if (!this.running) return;
        const dt = this.t ? Math.min(0.05, (t - this.t) / 1000) : 0;
        this.t = t;
        const tg = this.target();
        this.pos += (tg - this.pos) * (1 - Math.exp(-dt * 7));
        if (Math.abs(tg - this.pos) < 0.0008) this.pos = tg;
        this.place();
        if (this.pos !== tg || !dt) requestAnimationFrame(this.frameFn);
        else this.running = false;
      }
      place() {
        if (this.last !== null && Math.abs(this.last - this.pos) < 0.0005) return;
        this.last = this.pos;
        this.cards.forEach((el, i) => {
          const d = this.wrap(i - this.pos), a = Math.abs(d), k = Math.pow(0.78, a);
          const x = Math.sign(d) * 2.23 * (1 - k) * this.cw * this.spread;
          const op = Math.max(0, Math.min(1, this.maxD - a));
          el.style.transform = `translate3d(${x.toFixed(2)}px,0,0) scale(${k.toFixed(4)})`;
          el.style.opacity = op.toFixed(3);
          el.style.zIndex = 200 - Math.round(a * 20);
          el.style.visibility = op <= 0 ? 'hidden' : 'visible';
          el.classList.toggle('is-on', a < 0.35);
        });
        const n = this.n;
        this.show(((Math.round(this.pos) % n) + n) % n);
      }
      show(i) {
        if (this.cur === i) return;
        this.cur = i;
        const io = this.infoOwner[i], lo = this.labelOwner[i];
        [this.titles, this.descs, this.btns].forEach((list) => list.forEach((el, k) => el.classList.toggle('is-on', k === io)));
        this.labels.forEach((el, k) => el.classList.toggle('is-on', k === lo));
      }
      centreRow(i, instant) {
        const c = this.cards[i];
        if (!c) return;
        const left = c.offsetLeft - (this.track.clientWidth - c.offsetWidth) / 2;
        this.track.scrollTo({ left, behavior: instant || this.reduce.matches ? 'instant' : 'smooth' });
        this.syncRow(i);
      }
      syncRow(force) {
        let best = typeof force === 'number' ? force : 0;
        if (typeof force !== 'number') {
          const mid = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
          let bd = Infinity;
          this.cards.forEach((c, k) => {
            const r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
            if (d < bd) { bd = d; best = k; }
          });
        }
        this.cards.forEach((c, k) => c.classList.toggle('is-on', k === best));
        this.show(best);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-collection-grid')) {
    customElements.define('ie-collection-grid', class extends HTMLElement {
      connectedCallback() {
        this.mq = matchMedia('(max-width: 989px)');
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onDoc = this.onDoc.bind(this);
        this.onPop = this.onPop.bind(this);
        this.onMq = () => this.closeDrawer(true);
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.addEventListener('submit', this.onSubmit);
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('toggle', this.onToggle, true);
        this.addEventListener('cancel', this.onCancel, true);
        document.addEventListener('click', this.onDoc);
        window.addEventListener('popstate', this.onPop);
        this.mq.addEventListener('change', this.onMq);
        this.showActiveChip();
      }

      // keep the selected category chip in view when the row scrolls sideways (phones)
      showActiveChip() {
        const row = this.querySelector('.ie-cg__qcats');
        const on = row && row.querySelector('.ie-cg__qc.is-on');
        if (!on) return;
        const r = row.getBoundingClientRect(), c = on.getBoundingClientRect();
        if (c.left < r.left || c.right > r.right) row.scrollLeft += c.left - r.left - 24;
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDoc);
        window.removeEventListener('popstate', this.onPop);
        this.mq.removeEventListener('change', this.onMq);
        if (this.ctrl) this.ctrl.abort();
        this.unlock();
      }

      reduced() { return matchMedia('(prefers-reduced-motion: reduce)').matches; }
      drawer() { return this.querySelector('[data-cg-drawer]'); }
      dropdowns() { return [...this.querySelectorAll('[data-cg-fd]')]; }

      closeDropdowns(except) {
        if (this.mq.matches) return;
        this.dropdowns().forEach((d) => { if (d !== except) d.open = false; });
      }

      onToggle(e) {
        const d = e.target;
        if (d.matches && d.matches('[data-cg-fd]') && d.open && !this.mq.matches) this.closeDropdowns(d);
      }

      onDoc(e) {
        if (this.mq.matches) return;
        const inside = e.target.closest && e.target.closest('[data-cg-fd]');
        if (!inside || !this.contains(inside)) this.closeDropdowns();
      }

      onKey(e) {
        if (e.key !== 'Escape' || this.mq.matches) return;
        const open = this.dropdowns().find((d) => d.open);
        if (open) {
          open.open = false;
          open.querySelector('summary').focus();
        }
      }

      onCancel(e) {
        if (e.target.matches && e.target.matches('[data-cg-drawer]')) {
          e.preventDefault();
          this.closeDrawer();
        }
      }

      onClick(e) {
        const a = e.target.closest('a[data-cg-nav]');
        if (a && this.contains(a)) {
          if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          if (a.closest('[data-cg-drawer]')) this.closeDrawer(true);
          this.load(a.href, true, { top: a.hasAttribute('data-cg-top') });
          return;
        }
        if (e.target.closest('[data-cg-open]')) return this.openDrawer();
        if (e.target.closest('[data-cg-close]')) return this.closeDrawer();
        const d = e.target.closest('[data-cg-drawer]');
        if (d && e.target === d && d.open) {
          // a click on the dimmed backdrop lands on the dialog itself, outside its box
          const r = d.getBoundingClientRect();
          if (e.clientX > r.right || e.clientX < r.left || e.clientY < r.top || e.clientY > r.bottom) this.closeDrawer();
        }
      }

      onChange(e) {
        const t = e.target;
        if (t.matches('[data-cg-sort]')) return this.submit();
        if (!t.closest('[data-cg-fd]')) return;
        if (this.mq.matches) return; // in the drawer, Apply submits
        this.submit();
      }

      onSubmit(e) {
        if (!e.target.matches('[data-cg-form]')) return;
        e.preventDefault();
        this.submit();
      }

      submit() {
        const form = this.querySelector('[data-cg-form]');
        if (!form) return;
        const url = new URL(form.getAttribute('action'), location.origin);
        for (const [k, v] of new FormData(form)) {
          if (String(v).trim() !== '') url.searchParams.append(k, v);
        }
        this.closeDrawer(true);
        this.load(url.href, true);
      }

      openDrawer() {
        const d = this.drawer();
        if (!d || d.open) return;
        d.querySelectorAll('[data-cg-fd]').forEach((x) => { x.open = true; });
        d.classList.remove('is-closing');
        d.showModal();
        document.documentElement.setAttribute('scroll-lock', '');
        this.locked = true;
        const btn = this.querySelector('[data-cg-open]');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        const x = d.querySelector('[data-cg-close]');
        if (x) x.focus();
      }

      closeDrawer(instant) {
        const d = this.drawer();
        if (!d || !d.open) return;
        const done = () => {
          clearTimeout(this.closeTimer);
          d.classList.remove('is-closing');
          if (d.open) d.close();
          if (!this.mq.matches) d.querySelectorAll('[data-cg-fd]').forEach((x) => { x.open = false; });
          this.unlock();
          const btn = this.querySelector('[data-cg-open]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        };
        if (instant || this.reduced()) return done();
        d.classList.add('is-closing');
        this.closeTimer = setTimeout(done, 260);
      }

      unlock() {
        if (!this.locked) return;
        this.locked = false;
        document.documentElement.removeAttribute('scroll-lock');
      }

      onPop(e) {
        if (e.state && e.state.ieCg === this.dataset.section) this.load(location.href, false);
      }

      snapshot() {
        const open = this.mq.matches ? -1 : this.dropdowns().findIndex((d) => d.open);
        const a = document.activeElement;
        let focus = null;
        if (a && a !== this && this.contains(a)) {
          if (a.name) {
            focus = '[name="' + CSS.escape(a.name) + '"]' + (a.type === 'checkbox' ? '[value="' + CSS.escape(a.value) + '"]' : '');
          } else if (a.dataset.cgKey) {
            focus = '[data-cg-key="' + CSS.escape(a.dataset.cgKey) + '"]';
          }
        }
        return { open, focus };
      }

      restore(k) {
        if (k.open > -1) {
          const d = this.dropdowns()[k.open];
          if (d) d.open = true;
        }
        const el = k.focus && this.querySelector(k.focus);
        if (el) el.focus({ preventScroll: true });
      }

      toTop() {
        const off = 96;
        const top = this.getBoundingClientRect().top - off;
        if (Math.abs(top) < 4) return;
        const reduce = this.reduced();
        if (window.ieLenis) {
          window.ieLenis.scrollTo(this, { offset: -off, immediate: reduce });
          return;
        }
        const pw = document.querySelector('.page-wrapper');
        const own = pw && pw.scrollHeight > pw.clientHeight + 5 && /(auto|scroll)/.test(getComputedStyle(pw).overflowY);
        (own ? pw : window).scrollBy({ top, behavior: reduce ? 'instant' : 'smooth' });
      }

      async load(href, push, opts = {}) {
        const url = new URL(href, location.origin);
        url.searchParams.delete('section_id');
        if (window.Shopify && window.Shopify.designMode) {
          location.href = url.href;
          return;
        }
        const req = new URL(url.href);
        req.searchParams.set('section_id', this.dataset.section);
        if (this.ctrl) this.ctrl.abort();
        const ctrl = (this.ctrl = new AbortController());
        this.classList.add('is-loading');
        this.setAttribute('aria-busy', 'true');
        try {
          const get = () => fetch(req.href, { signal: ctrl.signal, headers: { Accept: 'text/html' } });
          let res = await get();
          if (res.status === 429) {
            // busy store: one calm retry before falling back to a normal page load
            await new Promise((r) => setTimeout(r, 1500));
            res = await get();
          }
          if (!res.ok) throw new Error('HTTP ' + res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const next = doc.querySelector('ie-collection-grid');
          if (!next) throw new Error('section missing');
          const keep = opts.top ? { open: -1, focus: null } : this.snapshot();
          if (push) {
            const st = history.state && typeof history.state === 'object' ? history.state : {};
            if (st.ieCg !== this.dataset.section) history.replaceState(Object.assign({}, st, { ieCg: this.dataset.section }), '', location.href);
            history.pushState({ ieCg: this.dataset.section }, '', url.pathname + url.search + url.hash);
          }
          const rowX = (this.querySelector('.ie-cg__qcats') || {}).scrollLeft || 0;
          this.innerHTML = next.innerHTML;
          const row = this.querySelector('.ie-cg__qcats');
          if (row) row.scrollLeft = rowX;
          this.restore(keep);
          this.showActiveChip();
          if (opts.top) {
            const grid = this.querySelector('.ie-cg__grid');
            if (grid) grid.focus({ preventScroll: true });
          }
          if (opts.top || this.getBoundingClientRect().top < 0) this.toTop();
          this.dispatchEvent(new CustomEvent('ie:collection:update', { bubbles: true, detail: { url: url.href } }));
        } catch (err) {
          if (err.name === 'AbortError') return;
          location.href = url.href;
        } finally {
          if (this.ctrl === ctrl) {
            this.ctrl = null;
            this.classList.remove('is-loading');
            this.removeAttribute('aria-busy');
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-contact')) {
    const IE_CT_DAYS = { all: [0, 1, 2, 3, 4, 5, 6], mon_sat: [1, 2, 3, 4, 5, 6], mon_fri: [1, 2, 3, 4, 5] };
    const IE_CT_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    customElements.define('ie-contact', class extends HTMLElement {
      connectedCallback() {
        this.status = this.querySelector('[data-ie-status]');
        if (this.status) {
          this.tick();
          this.clock = setInterval(() => this.tick(), 60000);
        }
        this.onClick = (e) => this.handleClick(e);
        this.onKey = (e) => this.handleKey(e);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
        this.setupChat();
        // after a form post Shopify reloads the page: bring the thank-you / error message into view
        const note = this.querySelector('.ie-ct__ok, .ie-ct__err');
        if (note && !window.Shopify?.designMode) {
          requestAnimationFrame(() => {
            note.scrollIntoView({ block: 'center', behavior: 'instant' });
            note.focus({ preventScroll: true });
          });
        }
      }

      disconnectedCallback() {
        clearInterval(this.clock);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
        this.stopWatch();
        (this.timers || []).forEach(clearTimeout);
      }

      /* Open or closed, worked out in India time (UTC+5:30) whatever the visitor's own time zone is. */
      tick() {
        const st = this.status, d = st.dataset;
        const days = IE_CT_DAYS[d.days] || IE_CT_DAYS.all;
        const on = (x) => days.includes(((x % 7) + 7) % 7);
        const t = new Date(Date.now() + 330 * 60000);
        const day = t.getUTCDay(), m = t.getUTCHours() * 60 + t.getUTCMinutes();
        const o = (+d.open) * 60, c = (+d.close) * 60;
        let open;
        if (c > 24 * 60 || c - o >= 24 * 60) open = on(day); // open round the clock
        else if (c > o) open = on(day) && m >= o && m < c;
        else open = (on(day) && m >= o) || (on(day - 1) && m < c); // hours run past midnight
        let back = d.openLabel;
        if (!open && !(on(day) && m < o)) {
          let k = 1;
          while (k < 7 && !on(day + k)) k++;
          if (k > 1) back += ' on ' + IE_CT_NAMES[(day + k) % 7];
        }
        st.classList.toggle('is-open', open);
        st.dataset.state = open ? 'open' : 'closed';
        const txt = st.querySelector('[data-ie-status-text]');
        const next = open ? d.tOpen : d.tClosed.split('[open]').join(back);
        if (txt && next && txt.textContent !== next) txt.textContent = next;
        const chat = this.querySelector('[data-ie-chat-st]');
        const chatNext = open ? d.cOpen : d.cClosed.split('[open]').join(back);
        if (chat && chatNext) chat.textContent = chatNext;
      }

      /* The phone plays its chat once, when it comes on screen. Position check on a capture-phase scroll
         listener: on desktop Atelier scrolls .page-wrapper, not the window. */
      setupChat() {
        const ph = this.querySelector('.ie-ct__phone');
        if (!ph || window.Shopify?.designMode || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        ph.classList.add('is-anim');
        this.onScroll = () => {
          if (!ph.getClientRects().length) return; // hidden on phones
          const r = ph.getBoundingClientRect();
          if (r.top >= innerHeight * 0.85 || r.bottom <= 0) return;
          this.stopWatch();
          this.timers = [[300, 'is-s1'], [1100, 'is-s2'], [2600, 'is-s3']].map(([ms, cls]) => setTimeout(() => ph.classList.add(cls), ms));
        };
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();
      }

      stopWatch() {
        if (!this.onScroll) return;
        document.removeEventListener('scroll', this.onScroll, true);
        window.removeEventListener('resize', this.onScroll);
        this.onScroll = null;
      }

      handleClick(e) {
        const cp = e.target.closest('[data-ie-copy]');
        if (cp) return this.copy(cp);
        const tp = e.target.closest('[data-ie-topic]');
        if (tp) this.pick(tp, false);
      }

      handleKey(e) {
        const tp = e.target.closest('[data-ie-topic]');
        if (!tp) return;
        const all = [...tp.parentElement.querySelectorAll('[data-ie-topic]')];
        let i = all.indexOf(tp);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') i = (i + 1) % all.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') i = (i - 1 + all.length) % all.length;
        else if (e.key === 'Home') i = 0;
        else if (e.key === 'End') i = all.length - 1;
        else return;
        e.preventDefault();
        this.pick(all[i], true);
      }

      pick(btn, focus) {
        btn.parentElement.querySelectorAll('[data-ie-topic]').forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        const input = this.querySelector('[data-ie-topic-input]');
        if (input) input.value = btn.dataset.ieTopic;
        if (focus) btn.focus();
      }

      copy(btn) {
        const text = btn.dataset.ieCopy;
        const fallback = () => {
          try {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.setAttribute('readonly', '');
            ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            ta.remove();
            btn.focus({ preventScroll: true });
          } catch (_) {}
        };
        try {
          const p = navigator.clipboard && navigator.clipboard.writeText(text);
          if (p && p.catch) p.catch(fallback);
          else if (!p) fallback();
        } catch (_) {
          fallback();
        }
        const label = btn.querySelector('[data-ie-copy-label]');
        const host = this.querySelector('.ie-ct__cards');
        btn.classList.add('is-done');
        if (label && host) label.textContent = host.dataset.copied || 'Copied';
        clearTimeout(btn._ieT);
        btn._ieT = setTimeout(() => {
          btn.classList.remove('is-done');
          if (label && host) label.textContent = host.dataset.copy || 'Copy';
        }, 2000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-dealer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-dealer')) {
    customElements.define('ie-dealer', class extends HTMLElement {
      connectedCallback() {
        this.card = this.querySelector('.ie-dl__card');
        this.nums = [...this.querySelectorAll('[data-ie-count]')]
          .map((el) => ({ el, txt: el.textContent.trim() }))
          .filter((n) => /^[\d,]+$/.test(n.txt) && parseInt(n.txt.replace(/,/g, ''), 10) > 0)
          .map((n) => ({ el: n.el, to: parseInt(n.txt.replace(/,/g, ''), 10) }));
        this.still = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.done = this.still;
        if (!this.still) {
          this.card.classList.add('is-anim');
          this.nums.forEach((n) => { n.el.textContent = '0'; });
        }
        // Atelier scrolls .page-wrapper on desktop, so listen in the capture phase and measure the box
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = 0; this.check(); });
        };
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.check();
      }
      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
        cancelAnimationFrame(this.countRaf);
        clearTimeout(this.tDone);
      }
      check() {
        const r = this.card.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        if (!r.height) return;
        // pause the flowing lines and pulses while the card is off screen
        this.classList.toggle('is-off', r.bottom < 0 || r.top > vh);
        if (!this.done && r.top < vh * 0.85) {
          this.done = true;
          this.reveal();
        }
      }
      reveal() {
        this.card.classList.add('is-in');
        this.tDone = setTimeout(() => this.card.classList.add('is-done'), 2200);
        const t0 = performance.now();
        const d = 1500;
        const step = (t) => {
          const k = Math.min(1, (t - t0) / d);
          const e = 1 - Math.pow(1 - k, 3);
          this.nums.forEach((n) => { n.el.textContent = Math.round(n.to * e).toLocaleString('en-IN'); });
          if (k < 1) this.countRaf = requestAnimationFrame(step);
        };
        this.countRaf = requestAnimationFrame(step);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-faq')) {
    customElements.define('ie-faq', class extends HTMLElement {
      connectedCallback() {
        // One answer open at a time; clicking the open one closes it.
        this.onClick = (e) => {
          const q = e.target.closest('.ie-faq__q');
          if (!q || !this.contains(q)) return;
          const item = q.closest('.ie-faq__item');
          this.show(item.classList.contains('is-on') ? null : item);
        };
        // Theme editor: selecting a question block opens it
        this.onSelect = (e) => {
          const item = e.target.closest && e.target.closest('.ie-faq__item');
          if (item && this.contains(item)) this.show(item);
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onSelect);
      }
      show(item) {
        this.querySelectorAll('.ie-faq__item').forEach((x) => {
          const on = x === item;
          x.classList.toggle('is-on', on);
          x.querySelector('.ie-faq__q').setAttribute('aria-expanded', String(on));
        });
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-footer')) {
    customElements.define('ie-footer', class extends HTMLElement {
      connectedCallback() {
        const still = matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Trust dock: rise in once it is on screen. A position check on scroll (not IntersectionObserver),
        // so a jump straight to the bottom (End key) still reveals it. Listen in the capture phase:
        // on desktop Atelier scrolls .page-wrapper, not the window, and element scroll events don't bubble.
        const dock = this.querySelector('.ie-dock');
        if (dock && !still && !window.Shopify?.designMode) {
          dock.classList.add('is-anim');
          this.onScroll = () => {
            if (dock.getBoundingClientRect().top < innerHeight * 0.92) {
              dock.classList.add('is-in');
              document.removeEventListener('scroll', this.onScroll, true);
            }
          };
          document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
          this.onScroll();
        }
        // Soft spotlight that follows the mouse
        if (dock && matchMedia('(hover: hover)').matches) {
          dock.querySelectorAll('.ie-dock__item').forEach((c) => {
            c.addEventListener('pointermove', (e) => {
              const r = c.getBoundingClientRect();
              c.style.setProperty('--mx', ((e.clientX - r.left) / r.width) * 100 + '%');
              c.style.setProperty('--my', ((e.clientY - r.top) / r.height) * 100 + '%');
            });
          });
        }

        // Phone: link columns open and close
        this.querySelectorAll('[data-fcol] .ie-ftr__h').forEach((h) => {
          h.addEventListener('click', () => {
            if (matchMedia('(min-width: 760px)').matches) return;
            const c = h.parentElement;
            const open = !c.classList.contains('is-open');
            c.classList.toggle('is-open', open);
            h.setAttribute('aria-expanded', String(open));
          });
        });

        // Back to top: scroll whichever element is scrolling (.page-wrapper on desktop, the page on phones)
        this.querySelector('[data-totop]')?.addEventListener('click', () => {
          if (window.ieLenis) return window.ieLenis.scrollTo(0); // smooth scrolling is on (desktop)
          const behavior = still ? 'auto' : 'smooth';
          document.querySelector('.page-wrapper')?.scrollTo({ top: 0, behavior });
          window.scrollTo({ top: 0, behavior });
        });
      }
      disconnectedCallback() {
        if (this.onScroll) document.removeEventListener('scroll', this.onScroll, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-hanky"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-hanky')) {
    customElements.define('ie-hanky', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.ie-hk__grid');
        this.imgs = [...this.querySelectorAll('.ie-hk__img')];
        this.tabs = [...this.querySelectorAll('.ie-hk__tab')];
        this.row = this.querySelector('.ie-hk__tabs');
        this.stage = this.querySelector('.ie-hk__stage');
        this.cap = this.querySelector('.ie-hk__cap');
        this.cur = 0;
        if (this.imgs[0]) this.imgs[0].classList.add('is-on');
        this.imgs.forEach((im, k) => { if (k) im.setAttribute('aria-hidden', 'true'); });
        // The other photos stay fully clipped until their tab opens, so lazy loading never fetches them.
        // Once the first photo has loaded (the section is near), fetch the rest quietly so each reveal shows a ready photo.
        const warm = () => this.imgs.forEach((im) => { if (im.loading === 'lazy') im.loading = 'eager'; });
        const first = this.imgs[0];
        if (first && first.tagName === 'IMG' && !first.complete) first.addEventListener('load', warm, { once: true });
        else warm();
        this.still = !this.hasAttribute('data-autoplay') || this.tabs.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.classList.toggle('is-still', this.still);
        if (!this.tabs.length) return;

        this.tabs.forEach((b, k) => {
          b.addEventListener('click', () => this.go(k));
          b.querySelector('.ie-hk__bar i').addEventListener('animationend', () => { if (!this.still) this.go(this.cur + 1); });
        });
        // Arrow keys move between tabs (one tab stop for the whole list)
        this.row.addEventListener('keydown', (e) => {
          const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
          let k = null;
          if (e.key in keys) k = this.cur + keys[e.key];
          else if (e.key === 'Home') k = 0;
          else if (e.key === 'End') k = this.tabs.length - 1;
          if (k === null) return;
          e.preventDefault();
          this.go(k);
          this.tabs[this.cur].focus();
        });
        // Pause: mouse over the section, keyboard focus in the tabs, or section off screen
        this.grid.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.classList.add('is-paused'); });
        this.grid.addEventListener('pointerleave', () => this.classList.remove('is-paused'));
        this.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) this.classList.add('is-focus'); });
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.classList.remove('is-focus'); });
        // Atelier scrolls .page-wrapper on desktop, so listen in the capture phase and measure the box
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = 0; this.checkOnScreen(); });
        };
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.checkOnScreen();
        // Theme editor: show the use being edited and hold it there
        this.onSelect = (e) => {
          const k = this.tabs.indexOf(e.target);
          if (k < 0) return;
          this.go(k);
          this.classList.add('is-edit');
        };
        this.onDeselect = (e) => { if (this.tabs.includes(e.target)) this.classList.remove('is-edit'); };
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
      }
      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
        clearTimeout(this.tPrev);
        clearTimeout(this.tCap);
      }
      checkOnScreen() {
        const r = this.grid.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const seen = Math.min(r.bottom, vh) - Math.max(r.top, 0);
        this.classList.toggle('is-off', !(r.height > 0 && seen >= Math.min(r.height, vh) * 0.25));
      }
      go(n) {
        const len = this.tabs.length;
        const i = ((n % len) + len) % len;
        if (i === this.cur) return;
        const old = this.cur;
        const a = this.imgs[old];
        const b = this.imgs[i];
        this.imgs.forEach((im) => im.classList.remove('is-prev'));
        if (a) { a.classList.remove('is-on'); a.classList.add('is-prev'); a.setAttribute('aria-hidden', 'true'); }
        if (b) { b.classList.add('is-on'); b.removeAttribute('aria-hidden'); }
        clearTimeout(this.tPrev);
        this.tPrev = setTimeout(() => { if (a && a !== this.imgs[this.cur]) a.classList.remove('is-prev'); }, 1050);
        this.tabs.forEach((t, k) => {
          const on = k === i;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        this.stage.setAttribute('aria-labelledby', this.tabs[i].id);
        if (this.cap) {
          const tab = this.tabs[i];
          this.cap.classList.add('is-out');
          clearTimeout(this.tCap);
          this.tCap = setTimeout(() => {
            this.cap.querySelector('b').textContent = tab.querySelector('b').textContent;
            this.cap.querySelector('span').textContent = tab.querySelector('small').textContent;
            this.cap.classList.remove('is-out');
          }, this.still ? 0 : 200);
        }
        // Phones: slide the pill row so the active pill is in view (the row only, never the page)
        if (this.row.scrollWidth > this.row.clientWidth + 2) {
          this.row.scrollTo({ left: Math.max(0, this.tabs[i].offsetLeft - 4), behavior: this.still ? 'auto' : 'smooth' });
        }
        this.cur = i;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-header"]) return;
  try {
    
  if (!customElements.get('ie-header')) {
    customElements.define('ie-header', class extends HTMLElement {
      connectedCallback() {
        this.megas = [...this.querySelectorAll('[data-mega]')];
        this.drawer = this.querySelector('.ie-drawer');
        this.burger = this.querySelector('[data-drawer-open]');

        // ---- mega dropdown: hover on mouse, click/tap and keyboard everywhere
        this.megas.forEach((li) => {
          const btn = li.querySelector('button');
          btn.addEventListener('click', () => this.toggleMega(li, !li.classList.contains('is-open')));
          li.addEventListener('pointerenter', (e) => {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(li._t);
            this.toggleMega(li, true);
          });
          li.addEventListener('pointerleave', (e) => {
            if (e.pointerType !== 'mouse') return;
            li._t = setTimeout(() => this.toggleMega(li, false), 160);
          });
          li.addEventListener('focusout', (e) => {
            if (!li.contains(e.relatedTarget)) this.toggleMega(li, false);
          });
          li.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && li.classList.contains('is-open')) { this.toggleMega(li, false); btn.focus(); }
          });
        });
        this.onDocClick = (e) => {
          this.megas.forEach((li) => { if (!li.contains(e.target)) this.toggleMega(li, false); });
        };
        document.addEventListener('click', this.onDocClick);

        // ---- phone drawer
        this.burger?.addEventListener('click', () => this.openDrawer());
        this.drawer?.addEventListener('click', (e) => {
          if (e.target === this.drawer || e.target.closest('[data-drawer-close]')) this.closeDrawer();
        });
        this.drawer?.addEventListener('cancel', (e) => { e.preventDefault(); this.closeDrawer(); });
        this.mq = matchMedia('(min-width: 990px)');
        this.onMq = () => { if (this.mq.matches && this.drawer?.open) this.closeDrawer(true); this.measure(); };
        this.mq.addEventListener('change', this.onMq);

        // ---- keep --header-height / --header-group-height exact for Atelier's sticky parts
        this.ro = new ResizeObserver(() => this.measure());
        this.ro.observe(this);
        const ann = document.querySelector('.ie-ann');
        if (ann) this.ro.observe(ann);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        this.mq?.removeEventListener('change', this.onMq);
        this.ro?.disconnect();
        document.documentElement.removeAttribute('scroll-lock');
      }
      measure() {
        const h = Math.round(this.offsetHeight);
        const group = document.getElementById('header-group');
        let total = 0;
        if (group) for (const el of group.querySelectorAll(':scope > .shopify-section')) total += el.offsetHeight;
        document.body.style.setProperty('--header-height', (this.classList.contains('is-sticky') ? h : 0) + 'px');
        document.body.style.setProperty('--header-group-height', Math.round(total || h) + 'px');
      }
      toggleMega(li, open) {
        clearTimeout(li._t);
        if (open) this.megas.forEach((o) => { if (o !== li) this.toggleMega(o, false); });
        li.classList.toggle('is-open', open);
        li.querySelector('button').setAttribute('aria-expanded', String(open));
      }
      openDrawer() {
        if (!this.drawer || this.drawer.open) return;
        this.drawer.classList.remove('is-closing');
        this.drawer.showModal();
        this.burger?.setAttribute('aria-expanded', 'true');
        document.documentElement.setAttribute('scroll-lock', ''); // Atelier's own page lock
      }
      closeDrawer(instant) {
        const d = this.drawer;
        if (!d || !d.open) return;
        const done = () => {
          d.classList.remove('is-closing');
          d.close();
          this.burger?.setAttribute('aria-expanded', 'false');
          document.documentElement.removeAttribute('scroll-lock');
        };
        if (instant || matchMedia('(prefers-reduced-motion: reduce)').matches) return done();
        d.classList.add('is-closing');
        d.addEventListener('animationend', done, { once: true });
        setTimeout(() => { if (d.open) done(); }, 400); // safety net if the animation is skipped
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-hero')) {
    customElements.define('ie-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.ie-hero__slide')];
        this.segs = [...this.querySelectorAll('.ie-hero__seg')];
        if (this.slides.length < 2) return;
        this.i = 0;
        // Autoplay runs off the progress bar animation, so it stops by itself for reduced motion
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) this.classList.add('is-static');
        this.addEventListener('click', (e) => {
          const b = e.target.closest('[data-go],[data-seg],[data-pause]');
          if (!b) return;
          if (b.dataset.go) this.go(this.i + Number(b.dataset.go));
          else if (b.dataset.seg) this.go(Number(b.dataset.seg));
          else this.pause(!this.classList.contains('is-paused'));
        });
        this.querySelector('.ie-hero__progress').addEventListener('animationend', () => {
          if (!this.classList.contains('is-paused')) this.go(this.i + 1);
        });
        let x0 = null;
        this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 50) this.go(this.i + (dx < 0 ? 1 : -1));
          x0 = null;
        }, { passive: true });
        // Theme editor: jump to the slide being edited and hold it there
        this.onSelect = (e) => {
          const k = this.slides.indexOf(e.target);
          if (k > -1) { this.go(k); this.pause(true); }
        };
        document.addEventListener('shopify:block:select', this.onSelect);
        // Load the other slides' photos once the page has settled (they are hidden until then)
        const later = () => (window.requestIdleCallback || setTimeout)(() => this.slides.forEach((s) => this.hydrate(s)), { timeout: 3000 });
        if (document.readyState === 'complete') later();
        else addEventListener('load', later, { once: true });
      }
      hydrate(slide) {
        slide.querySelectorAll('img[data-src]').forEach((img) => {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        });
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onSelect);
      }
      go(n) {
        const len = this.slides.length;
        this.i = (n + len) % len;
        this.hydrate(this.slides[this.i]);
        this.hydrate(this.slides[(this.i + 1) % len]); // and get the next one ready
        this.slides.forEach((s, k) => {
          s.classList.toggle('is-on', k === this.i);
          s.toggleAttribute('aria-hidden', k !== this.i);
          s.toggleAttribute('inert', k !== this.i);
        });
        this.segs.forEach((d, k) => {
          d.classList.remove('is-on');
          d.classList.toggle('is-done', k < this.i);
        });
        void this.segs[this.i].offsetWidth; // restart the progress animation
        this.segs[this.i].classList.add('is-on');
      }
      pause(on) {
        this.classList.toggle('is-paused', on);
        const b = this.querySelector('[data-pause]');
        if (b) b.setAttribute('aria-label', on ? 'Play slideshow' : 'Pause slideshow');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-product-recs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-product-recs')) {
    customElements.define('ie-product-recs', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.grid = this.querySelector('[data-recs-grid]');
        if (!this.grid.children.length) this.classList.add('is-empty');
        const url = this.dataset.url;
        if (!url || !window.fetch) return;
        // one retry if Shopify rate limits the request (the server-rendered cards stay meanwhile)
        const get = (n) => fetch(url, { headers: { Accept: 'text/html' } }).then((r) => {
          if (r.status === 429 && n > 0) return new Promise((ok) => setTimeout(ok, 1500)).then(() => get(n - 1));
          return r.ok ? r.text() : '';
        });
        get(2)
          .then((html) => {
            if (!html || !this.isConnected) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const box = doc.querySelector('[data-recs-result]');
            const recs = box ? [...box.querySelectorAll('.ie-pr__item')] : [];
            const local = [...this.grid.querySelectorAll('.ie-pr__item')];
            const limit = Number(this.dataset.limit) || 4;
            const list = this.dataset.order === 'related' ? local.concat(recs) : recs.concat(local);
            const seen = new Set();
            const pick = [];
            for (const el of list) {
              const h = el.dataset.handle;
              if (seen.has(h)) continue;
              seen.add(h);
              pick.push(el);
              if (pick.length >= limit) break;
            }
            const same = pick.length === local.length && pick.every((el, i) => el.dataset.handle === local[i].dataset.handle);
            if (!same) this.grid.replaceChildren(...pick.map((el) => document.importNode(el, true)));
            this.classList.toggle('is-empty', !pick.length);
          })
          .catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-social"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-social')) {
    customElements.define('ie-social', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.ie-soc__grid');
        if (!this.querySelector('.ie-soc__chat') || this.hasAttribute('data-still') || window.Shopify?.designMode) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        // Already on screen (or scrolled past) when the page starts: show the finished chat, no flash.
        if (this.seen()) return;
        this.classList.add('is-anim');
        // Play once the cards scroll into view. Position check on a capture-phase scroll listener:
        // on desktop Atelier scrolls .page-wrapper, not the window.
        this.onScroll = () => {
          if (!this.seen()) return;
          this.stop();
          this.timers = [[300, 'is-s1'], [1100, 'is-s2'], [2600, 'is-s3']].map(([t, c]) => setTimeout(() => this.classList.add(c), t));
        };
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
      }
      seen() {
        return this.grid.getClientRects().length > 0 && this.grid.getBoundingClientRect().top < innerHeight * 0.85;
      }
      stop() {
        if (!this.onScroll) return;
        document.removeEventListener('scroll', this.onScroll, true);
        window.removeEventListener('resize', this.onScroll);
        this.onScroll = null;
      }
      disconnectedCallback() {
        this.stop();
        (this.timers || []).forEach(clearTimeout);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-story')) {
    customElements.define('ie-story', class extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.ie-story__panel');
        if (!this.panel || this.hasAttribute('data-still') || window.Shopify?.designMode) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        // Already on screen (or scrolled past) when the page starts: keep the finished state, no flash.
        if (this.seen()) return;
        this.classList.add('is-anim');
        // Position check on scroll (not IntersectionObserver alone, so a jump scroll still reveals it).
        // Capture phase: on desktop Atelier scrolls .page-wrapper, whose scroll events don't bubble to window.
        this.onScroll = () => { if (this.seen()) this.reveal(); };
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
      }
      seen() {
        return this.panel.getClientRects().length > 0 && this.panel.getBoundingClientRect().top < innerHeight * 0.85;
      }
      reveal() {
        this.stop();
        this.classList.add('is-in');
        this.querySelectorAll('[data-count]').forEach((el) => {
          const to = +el.dataset.count, final = el.textContent, d = 1400;
          let t0 = 0;
          el.textContent = '0';
          const step = (t) => {
            if (!t0) t0 = t;
            const k = Math.min(1, (t - t0) / d);
            el.textContent = k < 1 ? Math.round(to * (1 - Math.pow(1 - k, 3))).toLocaleString('en-IN') : final;
            if (k < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        });
      }
      stop() {
        if (!this.onScroll) return;
        document.removeEventListener('scroll', this.onScroll, true);
        window.removeEventListener('resize', this.onScroll);
        this.onScroll = null;
      }
      disconnectedCallback() { this.stop(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-top-picks"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-top-picks')) {
    customElements.define('ie-top-picks', class extends HTMLElement {
      connectedCallback() {
        this.row = this.querySelector('[data-row]');
        this.nav = this.querySelector('[data-nav]');
        if (!this.row || !this.nav) return;
        this.track = this.nav.querySelector('[data-track]');
        this.thumb = this.nav.querySelector('[data-thumb]');
        [this.prev, this.next] = this.nav.querySelectorAll('[data-dir]');
        this.update = () => {
          const r = this.row, max = r.scrollWidth - r.clientWidth;
          this.nav.classList.toggle('is-off', max <= 2);
          const tw = this.track.clientWidth, w = tw * (r.clientWidth / r.scrollWidth);
          const x = max > 0 ? (tw - w) * (r.scrollLeft / max) : 0;
          this.thumb.style.width = w + 'px';
          this.thumb.style.transform = 'translateX(' + x.toFixed(1) + 'px)';
          this.prev.disabled = r.scrollLeft <= 2;
          this.next.disabled = r.scrollLeft >= max - 2;
        };
        this.row.addEventListener('scroll', this.update, { passive: true });
        this.nav.addEventListener('click', (e) => {
          const b = e.target.closest('[data-dir]');
          if (b) this.row.scrollBy({ left: Number(b.dataset.dir) * this.row.clientWidth, behavior: this.motion() });
        });
        this.track.addEventListener('click', (e) => {
          const r = this.track.getBoundingClientRect();
          const k = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
          this.row.scrollTo({ left: k * (this.row.scrollWidth - this.row.clientWidth), behavior: this.motion() });
        });
        this.ro = new ResizeObserver(this.update);
        this.ro.observe(this.row);
        this.update();
      }
      disconnectedCallback() { this.ro?.disconnect(); }
      motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
